import React, {Component} from 'react';
import Async from "../../../core/layout/Async";
import SystemTranslationLocaleService from "../services/SystemTranslationLocaleService";
import {observer} from "mobx-react";
import SystemTranslationLocaleCard from "./SystemTranslationLocaleCard";
import Column from "../../../core/layout/Column";
import Row from "../../../core/layout/Row";
import Separator from "../../../core/layout/Separator";

class SystemTranslationLocaleContainer extends Component {

    componentDidMount() {
        SystemTranslationLocaleService.load();
    }

    generateColumns() {
        return SystemTranslationLocaleService.locales.map(locale => (
            <Column size={6} key={locale.key}>
                <SystemTranslationLocaleCard
                    locale={locale}
                    onEdit={SystemTranslationLocaleService.openForm}
                    onDelete={SystemTranslationLocaleService.handleDelete}
                    canDelete={locale.canDelete}
                />
                <Separator/>
            </Column>
        ));
    }

    render() {
        return (
            <Async fetching={SystemTranslationLocaleService.fetch.fetching}>
                <Row>
                    {this.generateColumns()}
                </Row>
            </Async>
        );
    }

}

export default observer(SystemTranslationLocaleContainer);